// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_inputWrapper__DLNhS {
  position: relative;
  width: 100%;
  height: 64px;
}

.styles_input__lXXEW {
  width: 100%;
  height: 100%;
  padding: 16px;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-align: left;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
  background-color: transparent;
  border-radius: 16px;
  border: 1px solid #414141;
  outline: none;
  transition: 0.8s;
}
.styles_input__lXXEW:not([value=""]) {
  font-weight: 500;
  color: #ffffff;
}
.styles_input__lXXEW:hover {
  padding: 17px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid #b6b6b6;
  transition: 0.8s;
}
.styles_input__lXXEW:focus {
  padding: 16px;
  font-weight: 500;
  color: #ffffff;
  border: 1px solid #b6b6b6;
}
.styles_input__lXXEW::placeholder {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_input__lXXEW {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_inputError__810rg {
  border: 1px solid #d33030;
}
.styles_inputError__810rg:hover {
  border: 1px solid #d33030;
}
.styles_inputError__810rg:focus {
  border: 1px solid #d33030;
}

.styles_heading__1MkQp {
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}

.styles_wrapper__emoUW {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_error__P3Fkh {
  margin-top: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-align: right;
  text-transform: capitalize;
  color: #d33030;
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/inputTextWithHeading/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss","webpack://./src/assets/styles/mixin/breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BCbS;EDcT,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AAFF;AAGE;EACE,gBAAA;EACA,cC3BI;AD0BR;AAIE;EACE,aAAA;EACA,gBAAA;EACA,+BC1BO;ED2BP,yBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,gBAAA;EACA,cCzCI;ED0CJ,yBAAA;AAHJ;AAME;EACE,gBAAA;EACA,+BCzCO;ADqCX;AExBE;EFVF;IA0CI,eAAA;IACA,iBAAA;EAJF;AACF;;AAOA;EACE,yBAAA;AAJF;AAME;EACE,yBAAA;AAJJ;AAOE;EACE,yBAAA;AALJ;;AASA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BCpES;AD8DX;;AASA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cC5DI;ADsDN","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.inputWrapper {\n  position: relative;\n  width: 100%;\n  height: 64px;\n}\n\n.input {\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-align: left;\n  text-transform: capitalize;\n  color: $white-50;\n  background-color: transparent;\n  border-radius: 16px;\n  border: 1px solid $grey-input;\n  outline: none;\n  transition: 0.8s;\n  &:not([value='']) {\n    font-weight: 500;\n    color: $white;\n  }\n\n  &:hover {\n    padding: 17px;\n    font-weight: 500;\n    color: $white-70;\n    border: 1px solid $grey-nav;\n    transition: 0.8s;\n  }\n\n  &:focus {\n    padding: 16px;\n    font-weight: 500;\n    color: $white;\n    border: 1px solid $grey-nav;\n  }\n\n  &::placeholder {\n    font-weight: 300;\n    color: $white-50;\n  }\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.inputError {\n  border: 1px solid $red;\n\n  &:hover {\n    border: 1px solid $red;\n  }\n\n  &:focus {\n    border: 1px solid $red;\n  }\n}\n\n.heading {\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n}\n\n.wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.error {\n  margin-top: 8px;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-align: right;\n  text-transform: capitalize;\n  color: $red;\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `styles_inputWrapper__DLNhS`,
	"input": `styles_input__lXXEW`,
	"inputError": `styles_inputError__810rg`,
	"heading": `styles_heading__1MkQp`,
	"wrapper": `styles_wrapper__emoUW`,
	"error": `styles_error__P3Fkh`
};
export default ___CSS_LOADER_EXPORT___;
